/**
 * File: loginSchema.ts
 * Path: apps/admin/src/modules/auth/utils/loginSchema.ts
 * Description: What the login form accepts: a valid email, and a password of 6+ characters (or empty).
 */

import * as z from "zod";

export const loginSchema = z.object({
  email: z.string().email("Please enter a valid email address"),
  password: z
    .string()
    .min(6, "Password must be at least 6 characters")
    .or(z.literal("")),
});

export type LoginFormValues = z.infer<typeof loginSchema>;
